import { Record, List, fromJS } from 'immutable';

const phoneNumbers = [{
  type: '',
  country: '1',
  area: '',
  subscriber: '',
  extension: '',
  number: '',
}];

const postalAddress = [{
  street1: '',
  street2: '',
  city: '',
  state: '',
  country: 'US',
  postalCode: '',
}];

const operationHours = {
  sameHours: false,
  openWholeWeek: false,
  hoursList: [
    {
      dayOfWeek: 1,
      isOpen: true,
      shifts: [{
        open: '09:00:00',
        close: '17:00:00',
      }],
    },
    {
      dayOfWeek: 2,
      isOpen: true,
      shifts: [{
        open: '09:00:00',
        close: '17:00:00',
      }],
    },
    {
      dayOfWeek: 3,
      isOpen: true,
      shifts: [{
        open: '09:00:00',
        close: '17:00:00',
      }],
    },
    {
      dayOfWeek: 4,
      isOpen: true,
      shifts: [{
        open: '09:00:00',
        close: '17:00:00',
      }],
    },
    {
      dayOfWeek: 5,
      isOpen: true,
      shifts: [{
        open: '09:00:00',
        close: '17:00:00',
      }],
    },
    {
      dayOfWeek: 6,
      isOpen: true,
      shifts: [{
        open: '09:00:00',
        close: '17:00:00',
      }],
    },
    {
      dayOfWeek: 7,
      isOpen: true,
      shifts: [{
        open: '09:00:00',
        close: '17:00:00',
      }],
    },
  ],
};

const defaultValues = {
  id: null,
  brandId: null,
  indentifier: 'identifier',
  latitude: 0,
  longtitude: 0,
  timezoneOffset: 0,
  locale: 'US',
  phoneNumbers: fromJS(phoneNumbers),
  operationHours: fromJS(operationHours),
  postalAddress: fromJS(postalAddress),
};

export default class Location extends Record(defaultValues, Location) {
  constructor(values) {
    super({
      ...values,
      phoneNumbers: values && values.phoneNumbers
                        ? defaultValues.phoneNumbers
                          .mergeDeep(fromJS(values.phoneNumbers))
                        : defaultValues.phoneNumbers,
      operationHours: values && values.operationHours
                        ? defaultValues.operationHours
                          .mergeDeep(fromJS(values.operationHours))
                        : defaultValues.operationHours,
      postalAddress: values && values.postalAddress
                        ? defaultValues.postalAddress
                          .mergeDeep(fromJS(values.postalAddress))
                        : defaultValues.postalAddress,
    });
  }

  getDefaultPhoneNumber() {
    return this.get('phoneNumbers').first();
  }

  getDefaultPostalAddress() {
    return this.get('postalAddress').first();
  }

  updateDefaultPhoneNumber(number) {
    let defaultPhoneNumber = this.getDefaultPhoneNumber();
    const splitNumber = number.split('-');
    defaultPhoneNumber = defaultPhoneNumber.set('area', splitNumber[0]);
    defaultPhoneNumber = defaultPhoneNumber.set('subscriber', splitNumber[1]);
    defaultPhoneNumber = defaultPhoneNumber.set('extension', splitNumber[2]);
    return this.setIn(['phoneNumbers', 0], defaultPhoneNumber);
  }

  updateDefaultAddress(street1, street2, city, state, postalCode) {
    let defaultAddress = this.getDefaultPostalAddress();
    defaultAddress = defaultAddress.set('street1', street1);
    defaultAddress = defaultAddress.set('street2', street2);
    defaultAddress = defaultAddress.set('city', city);
    defaultAddress = defaultAddress.set('state', state);
    defaultAddress = defaultAddress.set('postalCode', postalCode);
    return this.setIn(['postalAddress', 0], defaultAddress);
  }

  getDefaultPhoneNumberFormatted() {
    const phone = this.getDefaultPhoneNumber();
    return phone.get('area')
            ? `${ phone.get('area') }-${ phone.get('subscriber') }-${ phone.get('extension') }`
            : '';
  }

  static getDefaultLocation(locations) {
    return locations.first();
  }

  static findLocatioIndexById(locations, locationId) {
    return locations.findIndex((location) => {
      return location.get('id') === locationId ? location : undefined;
    });
  }

  static findLocationByBrandId(locations, brandId) {
    return locations.find((location) => {
      return location.get('brandId') === brandId ? location : undefined;
    });
  }
}

export const Locations = (data) => {
  let locations = new List();
  if (data) {
    data.forEach((value) => {
      locations = locations.push(new Location(value));
    });
  }
  return locations;
};
